<script lang="ts">
  import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import { mdiDownload } from "@mdi/js"

  import { LetterPrintSelectionExpiredError } from "../../actions/downloadLetterPrintJob"

  import type {
    DownloadLetterPrintJobIntent,
    DownloadLetterPrintJobOperations,
    DownloadLetterPrintJobResult,
  } from "../../actions/downloadLetterPrintJob"

  let {
    intent,
    operations,
    onSubmissionResult,
    onPendingChange = undefined,
  }: {
    intent: DownloadLetterPrintJobIntent
    operations: DownloadLetterPrintJobOperations
    onSubmissionResult: (result: DownloadLetterPrintJobResult) => void | Promise<void>
    onPendingChange?: (pending: boolean) => void
  } = $props()
  let pending = $state(false)

  const run = async () => {
    if (pending || intent.kind !== "download") return

    pending = true
    onPendingChange?.(true)
    const request = {
      jobId: intent.jobId,
      organizationId: intent.organizationId,
      completeDelivery: intent.completeDelivery,
    }
    let result: Awaited<ReturnType<DownloadLetterPrintJobOperations["downloadPrintJob"]>>
    try {
      result = await operations.downloadPrintJob(request)
    } catch (error) {
      console.error("letter_delivery_manual_pdf_download_failed", error)
      newNotification({
        class: "error",
        html:
          error instanceof LetterPrintSelectionExpiredError
            ? "Die Briefauswahl ist nicht mehr aktuell. Bitte Auswahl aktualisieren und PDF neu erstellen."
            : "Zustell-PDF konnte nicht heruntergeladen werden.",
      })
      pending = false
      onPendingChange?.(false)

      return
    }

    try {
      await onSubmissionResult({
        kind: "downloaded",
        jobId: request.jobId,
        organizationId: request.organizationId,
        filename: result.filename,
        deliveryCompleted: result.deliveryCompleted,
      })
    } catch (error) {
      console.error("letter_delivery_manual_pdf_post_download_failed", error)
      newNotification({
        class: "error",
        html: result.deliveryCompleted
          ? "Die Briefe wurden abgeschlossen. Die Anzeige konnte nicht aktualisiert werden. Bitte erneut laden."
          : "Download vorbereitet, Oberfläche konnte nicht aktualisiert werden.",
      })
    } finally {
      pending = false
      onPendingChange?.(false)
    }
  }
</script>

<CTA
  type="primaryButton"
  small={true}
  content={pending ? "Download läuft" : intent.label}
  disabled={pending || intent.kind === "blocked"}
  tooltipContent={intent.kind === "blocked" ? intent.disabledReason : undefined}
  onClick={() => void run()}
>
  {#snippet iconSnippet()}<Icon path={mdiDownload} />{/snippet}
</CTA>
